<template>
    <div>
        <!-- Modal -->
        <div id="rulesOfEngagementModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ form.code ? form.code : 'New Project Data' }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="code"
                                       :class="{'text-red': form.errors.has('code')}">Project Data</label>
                                <input v-model="form.code" id="code" name="code" maxlength="15"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('code')}">
                                <div class="text-red text-xs" v-if="form.errors.has('code')">{{ form.errors.get('code')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="full_description"
                                       :class="{'text-red': form.errors.has('full_description')}">Full
                                    Description</label>
                                <input v-model="form.full_description" id="full_description" name="full_description"
                                       maxlength="150"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('full_description')}">
                                <div class="text-red text-xs" v-if="form.errors.has('full_description')">{{
                                    form.errors.get('full_description') }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="short_description"
                                       :class="{'text-red': form.errors.has('short_description')}">Short
                                    Description</label>
                                <input v-model="form.short_description" id="short_description" name="short_description"
                                       maxlength="75"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('short_description')}">
                                <div class="text-red text-xs" v-if="form.errors.has('short_description')">{{
                                    form.errors.get('short_description') }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="saved"
                                class="bg-followup-nav hover:bg-followup-nav-darker p-2 rounded text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="data.length > 0" class="text-grey-darkest">
            <div class="text-right">
                <button data-toggle="modal" data-target="#rulesOfEngagementModal"
                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                    add
                </button>
            </div>

            <div class="bg-white shadow-md rounded mb-6 mt-2">
                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Project Data
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-boldco uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Full Description
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Short Description
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                            Load Order
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            <span class="material-icons text-lg">lock</span>
                        </th>
                        <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
                    <draggable
                        draggable=".item-related"
                        v-model="options"
                        :element="'tbody'"
                        @change="handleOrderChange">
                        <tr @click="editCode(item)" class="hover:bg-grey-lighter cursor-pointer item-related" v-for="(item, index) in options">
                            <td class="pl-4 py-2 border-b border-grey-light text-xs w-25">
                                <i class="fa fa-align-justify handle pr-3"></i>
                            {{ item.code }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ item.full_description }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ item.short_description }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                            {{ item.load_order }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light">
                            <span class="material-icons text-base" v-if="item.locked">lock</span>
                        </td>
                        <td class="px-4 py-2 border-b border-grey-light text-right">
                            <button @click.stop="editCode(item)"
                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                            </button>
                            <button @click.stop="deleteCode(item)" v-if="!item.locked"
                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">delete
                            </button>
                        </td>
                    </tr>
                    </draggable>
                </table>
            </div>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="/images/blank.svg">
                </div>
                <div class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a code yet!</div>
                    </div>
                    <button @click="addCode" class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">Click here to add your first code!</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Form from "../../../utils/form";
    import draggable from 'vuedraggable';
    import Mixin from "./mixin";

    export default {
        name: 'rules-of-engagement',
        mixins: [Mixin],
        props: ['data', 'team'],
        components: {draggable},
        data() {
            return {
                editing: false,
                current_code: null,
                options: [],
                dataReorder:[],
                form: new Form({
                    code: '',
                    full_description: '',
                    short_description: '',
                    load_order: '0',
                }),
            }
        },
        created() {
            this.getOptionsArray(this.data);
        },
        mounted() {
            let self = this;
            $("#rulesOfEngagementModal").on('hidden.bs.modal', function () {
                self.form.reset();
                this.editing = false;
            });
        },

        methods: {
            saved() {
                let self = this;
                if (this.editing) {
                    this.form.put(route('api.settings.codes.rules-of-engagement.update', {code: this.current_code.id})).then(() => {
                        $("#rulesOfEngagementModal").modal("hide");
                        window.location = route('settings.codes.rules-of-engagement.index', {team: self.team.id});
                    });
                } else {
                    this.form.post(route('api.settings.codes.rules-of-engagement.store')).then(() => {
                        $("#rulesOfEngagementModal").modal("hide");
                        window.location = route('settings.codes.rules-of-engagement.index', {team: self.team.id});
                    });
                }
            },

            addCode() {
                $("#rulesOfEngagementModal").modal("show");
            },

            editCode(item) {
                $("#rulesOfEngagementModal").modal("show");
                this.current_code = item;
                this.editing = true;
                Object.assign(this.form, item);
            },

            deleteCode(item) {
                let self = this;
                Swal.fire({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this code!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'I\'m sure!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then((result) => {
                    if (result.value) {
                        self.form.delete(route('api.settings.codes.rules-of-engagement.destroy', {code: item.id})).then(() => {
                            window.location = route('settings.codes.rules-of-engagement.index', {team: self.team.id});
                        });
                    }
                });
            },

            handleOrderChange(event) {
                let self = this;
                if (event.moved) {
                    self.$nextTick(() => {
                        self.orderChange('rules_of_engagements');
                    });
                }
            },
        }
    }
</script>
